/* PerriPaws storefront — global behaviour (vanilla JS, no dependencies) */
(function () {
  'use strict';

  var PP = window.PerriPaws = window.PerriPaws || {};
  var routes = PP.routes || {};
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function rootUrl(path) {
    var root = routes.root || '/';
    if (root === '/') return path;
    return root.replace(/\/$/, '') + path;
  }
  PP.qs = qs; PP.qsa = qsa;

  /* ------------------------------------------------------------------
     Drawers & dialogs
     ------------------------------------------------------------------ */
  var openStack = [];

  /* The body scroll lock.
     Two jobs. First, freeze the page: body is pinned at -scrollY rather than merely given
     overflow:hidden, because overflow:hidden does not hold on iOS and some Android browsers,
     and because pinning drops the document scroll to 0 while a drawer is open - which is what
     makes the drawer's position independent of how far down the page the customer was.
     Second, never outlive the thing that justified it: the lock is derived from the DOM, not
     from openStack, because a drawer element can leave the DOM while still "open"
     (pp-collection.js replaces the whole collection section on every filter update, and the
     theme editor re-renders a section on any setting change). A stale entry is pruned and the
     lock is applied if and only if a drawer is genuinely open, so the page can never be left
     unscrollable. */
  var lockedAtY = 0;
  var isLocked = false;

  function syncLock() {
    openStack = openStack.filter(function (d) {
      return document.contains(d) && d.classList.contains('is-open');
    });
    var want = !!qs('.pp-drawer.is-open');
    if (want === isLocked) return;
    if (want) {
      lockedAtY = window.pageYOffset || document.documentElement.scrollTop || 0;
      document.body.style.top = (-lockedAtY) + 'px';
      document.body.classList.add('pp-lock');
      isLocked = true;
    } else {
      document.body.classList.remove('pp-lock');
      document.body.style.top = '';
      isLocked = false;
      /* Restore exactly where they were. scroll-behavior:smooth would animate this and land
         somewhere else, so it is suppressed for the one call. */
      var root = document.documentElement;
      var prev = root.style.scrollBehavior;
      root.style.scrollBehavior = 'auto';
      window.scrollTo(0, lockedAtY);
      root.style.scrollBehavior = prev;
    }
  }

  /* A fresh Add to Cart shows the top of the cart, not wherever the list was left scrolled.
     Only the drawer's own scroll container is touched; the document is never scrolled. */
  function resetDrawerScroll(drawer) {
    qsa('.pp-cdrawer__body, .pp-drawer__body', drawer).forEach(function (el) { el.scrollTop = 0; });
  }
  PP.resetDrawerScroll = resetDrawerScroll;

  function openDrawer(drawer, trigger) {
    if (!drawer) return;
    if (drawer.classList.contains('is-open')) {
      // Reconcile rather than return silently: a repeat Add to Cart on an already-open drawer
      // should still re-lock if something cleared the lock, and should show the top of the cart.
      syncLock();
      resetDrawerScroll(drawer);
      return;
    }
    openStack.forEach(function (d) { if (d !== drawer) closeDrawer(d, true); });
    drawer._ppTrigger = trigger || document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    openStack.push(drawer);
    syncLock();
    resetDrawerScroll(drawer);
    qsa('[aria-controls="' + drawer.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    window.setTimeout(function () {
      var close = qs('[data-pp-close].pp-drawer__close, .pp-drawer__close', drawer) || qs('.pp-drawer__panel', drawer);
      if (close) close.focus({ preventScroll: true });
    }, 60);
    drawer.dispatchEvent(new CustomEvent('pp:drawer:open', { bubbles: true }));
  }

  function closeDrawer(drawer, silent) {
    // Reconcile even on the early return: a close aimed at a drawer that is already closed is
    // exactly what happens after its predecessor was replaced in the DOM, and that is the case
    // that used to leave the lock stranded.
    if (!drawer || !drawer.classList.contains('is-open')) { syncLock(); return; }
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    openStack = openStack.filter(function (d) { return d !== drawer; });
    syncLock();
    qsa('[aria-controls="' + drawer.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (!silent && drawer._ppTrigger && document.contains(drawer._ppTrigger)) {
      try { drawer._ppTrigger.focus({ preventScroll: true }); } catch (e) {}
    }
    drawer.dispatchEvent(new CustomEvent('pp:drawer:close', { bubbles: true }));
  }
  PP.openDrawer = openDrawer;
  PP.closeDrawer = closeDrawer;

  /* A page restored from the back-forward cache keeps whatever classes it had when the user
     navigated away, so reconcile the lock against the restored DOM as well. */
  window.addEventListener('pageshow', syncLock);


  /* A frozen page is one the visitor cannot interact with, so recovery must not depend on them
     tapping something. Watching for DOM changes catches the moment a drawer element is removed
     or replaced and clears the lock on the next frame, with no user action at all. Coalesced to
     one check per frame, so a busy re-render costs a single querySelector. */
  if (window.MutationObserver) {
    var lockCheckQueued = false;
    new MutationObserver(function () {
      if (lockCheckQueued) return;
      lockCheckQueued = true;
      // a timeout rather than requestAnimationFrame, so the lock is still reconciled on a tab
      // the browser has stopped painting
      window.setTimeout(function () { lockCheckQueued = false; syncLock(); }, 0);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-pp-open]');
    if (opener) {
      e.preventDefault();
      openDrawer(document.getElementById(opener.getAttribute('data-pp-open')), opener);
      return;
    }
    var cartOpener = e.target.closest('[data-pp-open-cart]');
    if (cartOpener && PP.cartType !== 'page' && document.getElementById('pp-cart-drawer') && !document.body.classList.contains('template-cart')) {
      e.preventDefault();
      openDrawer(document.getElementById('pp-cart-drawer'), cartOpener);
      return;
    }
    var closer = e.target.closest('[data-pp-close]');
    if (closer) {
      var d = closer.closest('[data-pp-drawer]');
      if (d) { e.preventDefault(); closeDrawer(d); }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (openStack.length) closeDrawer(openStack[openStack.length - 1]);
      closeMega();
    }
    if (e.key === 'Tab' && openStack.length) {
      var drawer = openStack[openStack.length - 1];
      var items = qsa(FOCUSABLE, qs('.pp-drawer__panel', drawer)).filter(function (el) { return el.offsetParent !== null; });
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ------------------------------------------------------------------
     Toggles / accordions
     ------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pp-toggle]');
    if (!btn) return;
    var target = document.getElementById(btn.getAttribute('aria-controls'));
    if (!target) return;
    e.preventDefault();
    var willOpen = btn.getAttribute('aria-expanded') !== 'true';
    var group = btn.closest('[data-pp-accordion-single]');
    if (group && willOpen) {
      qsa('[data-pp-toggle][aria-expanded="true"]', group).forEach(function (other) {
        if (other === btn) return;
        other.setAttribute('aria-expanded', 'false');
        var t = document.getElementById(other.getAttribute('aria-controls'));
        if (t) t.hidden = true;
        var wrap = other.closest('[data-pp-acc-item]');
        if (wrap) wrap.classList.remove('is-open');
      });
    }
    btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    target.hidden = !willOpen;
    var item = btn.closest('[data-pp-acc-item]');
    if (item) item.classList.toggle('is-open', willOpen);
  });

  /* ------------------------------------------------------------------
     Mega menu
     ------------------------------------------------------------------ */
  var megaCloseTimer;
  function megaEls() {
    var trigger = qs('[data-pp-mega-trigger]');
    var panel = qs('[data-pp-mega]');
    return { trigger: trigger, panel: panel };
  }
  function openMega() {
    var m = megaEls();
    if (!m.panel) return;
    clearTimeout(megaCloseTimer);
    m.panel.hidden = false;
    m.trigger.setAttribute('aria-expanded', 'true');
  }
  function closeMega() {
    var m = megaEls();
    if (!m.panel || m.panel.hidden) return;
    m.panel.hidden = true;
    m.trigger.setAttribute('aria-expanded', 'false');
  }
  function scheduleCloseMega() {
    clearTimeout(megaCloseTimer);
    megaCloseTimer = setTimeout(closeMega, 160);
  }
  function initMega() {
    var m = megaEls();
    if (!m.trigger || !m.panel) return;
    var header = m.trigger.closest('[data-pp-header]');
    m.trigger.addEventListener('mouseenter', openMega);
    m.trigger.addEventListener('click', function () {
      if (m.panel.hidden) openMega(); else closeMega();
    });
    m.panel.addEventListener('mouseenter', function () { clearTimeout(megaCloseTimer); });
    m.panel.addEventListener('mouseleave', scheduleCloseMega);
    var nav = qs('[data-pp-mega-root]', header);
    if (nav) nav.addEventListener('mouseleave', scheduleCloseMega);
    qsa('.pp-nav__link, .pp-header__search, .pp-cart-btn', header).forEach(function (el) {
      el.addEventListener('mouseenter', scheduleCloseMega);
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-pp-mega]') && !e.target.closest('[data-pp-mega-trigger]')) closeMega();
    });
    m.panel.addEventListener('focusout', function (e) {
      if (!m.panel.contains(e.relatedTarget) && e.relatedTarget !== m.trigger) closeMega();
    });
  }

  /* ------------------------------------------------------------------
     Cart (Shopify AJAX Cart API + Section Rendering API)
     ------------------------------------------------------------------ */
  function cartSections() {
    var ids = ['pp-cart-drawer'];
    qsa('[data-pp-cart-section]').forEach(function (el) {
      var id = el.getAttribute('data-pp-cart-section');
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  function renderCartSections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      var html = sections[id];
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      if (id === 'pp-cart-drawer') {
        var fresh = qs('[data-pp-cart-drawer-content]', doc);
        var current = qs('[data-pp-cart-drawer-content]');
        if (fresh && current) {
          current.replaceWith(fresh);
          updateCount(fresh.getAttribute('data-cart-count'));
        }
      } else {
        var freshSection = qs('[data-pp-cart-section="' + id + '"]', doc);
        var currentSection = qs('[data-pp-cart-section="' + id + '"]');
        if (freshSection && currentSection) currentSection.replaceWith(freshSection);
      }
    });
    document.dispatchEvent(new CustomEvent('pp:cart:updated'));
  }

  function updateCount(count) {
    if (count === null || count === undefined) return;
    qsa('[data-pp-cart-count]').forEach(function (el) { el.textContent = count; });
    qsa('.pp-cart-btn').forEach(function (el) { el.setAttribute('aria-label', 'Open cart, ' + count + ' items'); });
  }

  function showCartError(message) {
    var box = qs('[data-pp-cart-error]');
    if (box) {
      box.textContent = message;
      box.hidden = false;
    }
  }

  function setBusy(on) {
    var d = document.getElementById('pp-cart-drawer');
    if (d) d.classList.toggle('is-busy', !!on);
    qsa('[data-pp-cart-section]').forEach(function (el) { el.classList.toggle('is-busy', !!on); });
  }

  PP.addToCart = function (formData, button) {
    var sections = cartSections();
    formData.append('sections', sections.join(','));
    formData.append('sections_url', window.location.pathname);
    var original = button ? button.innerHTML : null;
    if (button) {
      button.setAttribute('aria-busy', 'true');
      button.disabled = true;
      button.textContent = (PP.strings && PP.strings.adding) || 'Adding…';
    }
    /* No timeout previously existed. On a flaky mobile network a hung request left the button
       disabled showing "Adding..." with no way back, which reads to the customer exactly like
       "add to cart did nothing". 15s then abort, and .finally always restores the button. */
    var ctl = ('AbortController' in window) ? new AbortController() : null;
    var timer = window.setTimeout(function () { if (ctl) ctl.abort(); }, 15000);

    return fetch(routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: formData,
      signal: ctl ? ctl.signal : undefined
    })
      .then(function (r) { return r.json().then(function (json) { return { ok: r.ok, json: json }; }); })
      .then(function (res) {
        if (!res.ok || res.json.status) {
          var msg = res.json.description || res.json.message || (PP.strings && PP.strings.cartError);
          var inlineError = button && button.closest('form') ? qs('[data-pp-form-error]', button.closest('form').parentNode) : null;
          if (inlineError) { inlineError.textContent = msg; inlineError.hidden = false; }
          else { showCartError(msg); openDrawer(document.getElementById('pp-cart-drawer')); }
          return null;
        }
        if (PP.cartType === 'page') {
          window.location.href = routes.cart;
          return res.json;
        }
        renderCartSections(res.json.sections);
        /* The item IS in the cart at this point. If the drawer cannot be presented even after
           being forced, openDrawer releases it so an invisible full-screen panel can never
           swallow taps; the header cart button and the updated count remain the route to the
           cart. Deliberately NOT an automatic redirect: a false positive would yank a customer
           off the product page, which is worse than the drawer not animating. */
        openDrawer(document.getElementById('pp-cart-drawer'), button);
        document.dispatchEvent(new CustomEvent('pp:cart:added', { detail: res.json }));
        return res.json;
      })
      .catch(function () {
        showCartError((PP.strings && PP.strings.cartError) || 'Something went wrong.');
      })
      .finally(function () {
        window.clearTimeout(timer);
        if (button) {
          button.disabled = false;
          button.removeAttribute('aria-busy');
          if (original !== null) button.innerHTML = original;
        }
      });
  };

  PP.changeLine = function (key, quantity) {
    setBusy(true);
    return fetch(routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity, sections: cartSections(), sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json().then(function (json) { return { ok: r.ok, json: json }; }); })
      .then(function (res) {
        if (!res.ok || res.json.status) {
          showCartError(res.json.description || res.json.message || 'That quantity is not available.');
          return;
        }
        renderCartSections(res.json.sections);
      })
      .catch(function () { showCartError('Something went wrong. Please refresh and try again.'); })
      .finally(function () { setBusy(false); });
  };

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-pp-product-form]');
    if (!form) return;
    if (e.submitter && e.submitter.hasAttribute('data-pp-buy-now')) return;
    if (PP.cartType === 'page') return;
    e.preventDefault();
    var button = e.submitter && e.submitter.hasAttribute('data-pp-submit') ? e.submitter : qs('[data-pp-submit]', form);
    PP.addToCart(new FormData(form), button);
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pp-line-qty]');
    if (!btn) return;
    e.preventDefault();
    PP.changeLine(btn.getAttribute('data-pp-line-qty'), parseInt(btn.getAttribute('data-qty'), 10) || 0);
  });

  /* Cart cross-sells are rendered by pp-cart-drawer.liquid from the curated
     pdp.pairs_with relationships, and the whole drawer is re-rendered from the Section
     Rendering API after every cart mutation, so they are always current. The old
     intent=related fetch that used to live here has been removed: it depended on order
     history this store does not yet have, and it raced the drawer repaint. */

  /* ------------------------------------------------------------------
     Horizontal rails
     ------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pp-rail-dir]');
    if (!btn) return;
    var rail = document.getElementById(btn.getAttribute('aria-controls'));
    if (!rail) return;
    var dir = parseInt(btn.getAttribute('data-pp-rail-dir'), 10) || 1;
    var cap = parseInt(btn.getAttribute('data-pp-rail-cap'), 10) || 420;
    rail.scrollLeft += dir * Math.min(rail.clientWidth * 0.85, cap);
  });

  /* ------------------------------------------------------------------
     Tag tabs (e.g. Best Sellers: All / Dogs / Cats)
     ------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-pp-tag-tab]');
    if (!tab) return;
    var wrap = tab.closest('[data-pp-tabs]');
    var grid = wrap ? document.getElementById(wrap.getAttribute('data-target')) : null;
    if (!grid) return;
    qsa('[data-pp-tag-tab]', wrap).forEach(function (t) { t.setAttribute('aria-pressed', t === tab ? 'true' : 'false'); });
    var tags = (tab.getAttribute('data-pp-tag-tab') || '').toLowerCase().split(',').map(function (t) { return t.trim(); }).filter(Boolean);
    var limit = parseInt(grid.getAttribute('data-limit'), 10) || 999;
    var shown = 0;
    qsa('[data-pp-card-wrap]', grid).forEach(function (card) {
      var cardTags = (card.getAttribute('data-tags') || '').split('|');
      var match = !tags.length || tags.some(function (t) { return cardTags.indexOf(t) > -1; });
      var visible = match && shown < limit;
      card.hidden = !visible;
      if (visible) shown++;
    });
    var empty = qs('[data-pp-tabs-empty]', grid.parentNode);
    if (empty) empty.hidden = shown > 0;
  });

  /* ------------------------------------------------------------------
     Init
     ------------------------------------------------------------------ */
  function init() {
    initMega();
    qsa('[data-pp-drawer]').forEach(function (d) {
      if (d.parentNode !== document.body && d.id !== 'pp-cart-drawer' && !d.hasAttribute('data-pp-keep-in-section')) {
        // keep drawers inside their section in the editor; move to body on the storefront to escape stacking contexts
        if (!window.Shopify || !window.Shopify.designMode) document.body.appendChild(d);
      }
    });
    qsa('[data-pp-requires]').forEach(function (el) {
      if (document.querySelector(el.getAttribute('data-pp-requires'))) el.hidden = false;
    });
    qsa('[data-pp-tabs]').forEach(function (wrap) {
      var active = qs('[data-pp-tag-tab][aria-pressed="true"]', wrap) || qs('[data-pp-tag-tab]', wrap);
      if (active) active.click();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function () { initMega(); });
})();
